export default class AccountingService {
    constructor($http, appConfig) {
      "ngInject";
  
      this.$http = $http;
      this.appConfig = appConfig;
    }
  
    listProducts(filterParams) {
        let query = '';
    
        query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
        query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
        query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
        query += `&ascending=${filterParams.pageCriteria.ascending}`;
        query += `&entityId=${filterParams.entityId}`;
    
        if (filterParams.title) {
          query += `&title=${filterParams.title}`;
        }
    
        if (filterParams.createdBy) {
          query += `&createdBy=${filterParams.createdBy}`;
        }

        if (filterParams.status) {
          query += `&status=${filterParams.status}`;
        }
    
        return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/listproducts' + query);
    }

    addProduct(entityId, product) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/addproduct/${entityId}`, product);
    }    

    getProduct(productId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/getproduct/${productId}`);
    }    
    
    editProduct(entityId, product) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/editproduct/${entityId}`, product);
    }    
    
    updateProductStatus(entityId, productId, status) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/updateproductstatus/${entityId}/${productId}/${status}`);
    }      
    
    listInvoices(filterParams) {
      let query = '';
  
      query += `?pageStart=${filterParams.pageCriteria.pageStart}`;
      query += `&itemsToFetch=${filterParams.pageCriteria.itemsToFetch}`;
      query += `&sortExpression=${filterParams.pageCriteria.sortExpression}`;
      query += `&ascending=${filterParams.pageCriteria.ascending}`;
      query += `&entityId=${filterParams.entityId}`;
  
      if (filterParams.number) {
        query += `&number=${filterParams.number}`;
      }
  
      if (filterParams.contact) {
        query += `&contact=${filterParams.contact}`;
      }

      if (filterParams.status) {
        query += `&status=${filterParams.status}`;
      }
  
      return this.$http.get(this.appConfig.apiServiceBaseUri + 'api/accounting/invoice/list' + query);
  }

    createContact(entityId, contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/createcontact/${entityId}`, contact);
    }   

    editContact(entityId, contactId, contact) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/editcontact/${entityId}/${contactId}`, contact);
    }       

    saveDraft(entityId, invoice) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/savedraft/${entityId}`, invoice);
    }

    getInvoice(invoiceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/get/${invoiceId}`);
    }    

    updateInvoiceStatus(invoiceId, status) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/updatestatus/${invoiceId}/${status}`);
    }

    issueInvoice(invoiceId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/issue/${invoiceId}`);
    }    

    updatePayment(entityId, invoiceId, payment) {
      return this.$http.post(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/addpayment/${entityId}/${invoiceId}`, payment);
    } 
    
    deletePayment(entityId, invoicePaymentId) {
      return this.$http.get(this.appConfig.apiServiceBaseUri + `api/accounting/invoice/deletepayment/${entityId}/${invoicePaymentId}`);
    }     
  }


// WEBPACK FOOTER //
// ./client/app/components/accounting/accounting.service.js